import React from 'react';
import styles from './LoadingSpinner.module.css';

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  color?: string;
  className?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = 'medium', 
  color = 'var(--primary-color)',
  className = ''
}) => {
  return (
    <div className={`${styles.spinner} ${styles[size]} ${className}`}>
      <div 
        className={styles.spinnerRing}
        style={{ borderColor: `${color} transparent transparent transparent` }}
      />
    </div>
  );
};

export default LoadingSpinner;
